<template>
  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <header class="mdl-layout__header">
      <div class="mdl-layout__header-row page-header">
        <back-navigator></back-navigator>
        <span id="toolbar-title" class="mdl-layout-title">{{ $t('message.pageTitle') }}</span>
      </div>
    </header>
    <main>
      <div ref="spinner" class="spinner mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active"></div>
    </main>
    <footer-component></footer-component>
    <dialog-component
      :status="dialogStatus"
      :title="dialogTitle"
      :message="dialogMsg"
      :positiveAction="dialogPositiveAction"
      v-on:dialogAccepted="dialogAccepted()">
    </dialog-component>
    <cookie-policy-banner :userLang="userLocale"></cookie-policy-banner>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueI18n from 'vue-i18n'
  import groupService from '../services/groupService'
  import eventTracker from '../services/eventTracker'
  import backNavigator from './BackNavigationComponent'
  import footerComponent from './Footer'
  import dialogComponent from './DialogComponent'
  import cookiePolicyBanner from './CookiePolicyBanner'
  import Constants from '../Constants'
  var MDLite = require('material-design-lite/dist/material.min.js')
  var componentHandler = MDLite.componentHandler

  const messages = {
    en: {
      message: {
        pageTitle: 'Groups',
        openInAppAction: 'OPEN IN APP',
        joinGroupConfirmationTitle: 'Join this group?',
        joinGroupConfirmationMsg: 'The group admins will be notified about your request. You will be a group member once your request is accepted',
        joinGroupAction: 'JOIN GROUP',
        requestSubmittedTitle: 'Request Submitted',
        requestSubmittedDesc: 'Download the  Android app to get notified when your request is accepted',
        alreadyAGroupMember: 'You are already a group member',
        requestNotYetAccepted: 'Your request to join this group hasn\'t been accepted yet',
        requestRejected: 'Your request to join this group has been rejected',
        noGroupExists: 'The group you are trying to join doesn\'t exist',
        OKAction: 'Ok'
      }
    },
    hi: {
      message: {
        pageTitle: 'ग्रुप',
        openInAppAction: 'ऐप खोलें',
        joinGroupConfirmationTitle: 'Join group?',
        joinGroupConfirmationMsg: 'The group admins will be notified about your request. You will be a group member once your request is accepted',
        joinGroupAction: 'JOIN GROUP',
        requestSubmittedTitle: 'Request Submitted',
        requestSubmittedDesc: 'Download the  Android app to get notified when your request is accepted',
        alreadyAGroupMember: 'You are already a group member',
        requestNotYetAccepted: 'Your request to join this group hasn\'t been accepted yet',
        requestRejected: 'Your request to join this group has been rejected',
        noGroupExists: 'The group you are trying to join doesn\'t exist',
        OKAction: 'ठीक हैं'
      }
    }
  }

  Vue.use(VueI18n)

  const i18n = new VueI18n({
    locale: typeof (Storage) !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en',
    messages: messages
  })

  export default {
    i18n,
    components: {
      backNavigator: backNavigator,
      footerComponent: footerComponent,
      dialogComponent: dialogComponent,
      cookiePolicyBanner: cookiePolicyBanner
    },
    data () {
      return {
        userLocale: i18n.locale,
        groupId: null,
        dialogTitle: null,
        dialogMsg: '',
        dialogStatus: 'closed',
        dialogPositiveAction: 'OK',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.app.pollscape.release&utm_source=web'
      }
    },
    methods: {
      showDialog (title, msg, positiveAction) {
        this.dialogTitle = title
        this.dialogMsg = msg
        this.dialogPositiveAction = positiveAction
        this.dialogStatus = 'opened'
      },
      dialogAccepted () {
        this.dialogStatus = 'closed'
        if (this.dialogPositiveAction === i18n.t('message.joinGroupAction')) {
          groupService.joinGroup(this.groupId).then((isRequestSubmitted) => {
            if (isRequestSubmitted) {
              this.showDialog(i18n.t('message.requestSubmittedTitle'), i18n.t('message.requestSubmittedDesc'), i18n.t('message.openInAppAction'))
            } else {
              this.showDialog(null, i18n.t('message.noGroupExists'), i18n.t('message.OKAction'))
            }
          })
        } else if (this.dialogPositiveAction === i18n.t('message.openInAppAction')) {
          this.playStoreLink = `https://nzm2j.app.goo.gl/?link=https://pollscape-d2b4b.firebaseapp.com/groups/${this.groupId}/&apn=com.app.pollscape.release`
          window.location = this.playStoreLink
          eventTracker.trackAppDownloadLink()
        }
      }
    },
    async mounted () {
      let _this = this
      _this.groupId = window.location.href.split('/')[4]
      componentHandler.upgradeAllRegistered()

      try {
        if (await groupService.isGroupMember(_this.groupId)) {
          this.showDialog(null, i18n.t('message.alreadyAGroupMember'), i18n.t('message.openInAppAction'))
        } else {
          const memberRequestStatus = await groupService.getMemberRequestStatus(_this.groupId)
          if (memberRequestStatus === Constants.MemberRequestStatus.PENDING) {
            _this.showDialog(null, i18n.t('message.requestNotYetAccepted'), i18n.t('message.openInAppAction'))
          } else if (memberRequestStatus === Constants.MemberRequestStatus.REJECTED) {
            _this.showDialog(null, i18n.t('message.requestRejected'), i18n.t('message.OKAction'))
          } else {
            this.showDialog(i18n.t('message.joinGroupConfirmationTitle'), i18n.t('message.joinGroupConfirmationMsg'), i18n.t('message.joinGroupAction'))
          }
        }
        this.$refs.spinner.classList.remove('is-active')
      } catch (error) {
        console.log(error)
      }
    }
  }
</script>

<style scoped>
  main {
    min-height: calc(100vh - 224px);
    padding: 20px;
    margin-left: 55px;
  }

  @media only screen and (max-width: 600px) {
    main {
      margin-left: 5px;
    }
  }

  .spinner {
    display: block;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  footer-component {
    height: 120px;
  }
</style>




// WEBPACK FOOTER //
// src/components/GroupPollsView.vue